import React from 'react'
import '../sass/main.scss'

const Template = ({ children }) => (
  <div>
    {children}
  </div>
  )

Template.propTypes = {
  children: React.PropTypes.any,
}

export default Template



// WEBPACK FOOTER //
// ./_template.jsx